import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { PayoutLineItemsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createPayoutLineItem = (data): any => action(types.CREATE_PAYOUT_LINE_ITEM_REQUESTED, data);

export const updatePayoutLineItem = (data): any => action(types.UPDATE_PAYOUT_LINE_ITEM_REQUESTED, data);

export const deletePayoutLineItem = (payoutLineItemId): any => action(types.DELETE_PAYOUT_LINE_ITEM_REQUESTED, payoutLineItemId);

export const getPayoutLineItem = (payoutLineItemId): any => action(types.GET_PAYOUT_LINE_ITEM_REQUESTED, payoutLineItemId);

export const getAllPayoutLineItems = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_PAYOUT_LINE_ITEMS_REQUESTED, { pagination, compile });

export const getAllPayoutLineItemsPayoutLineItemView = (
  pagination: IPagination = undefined,
  compile = true,
  teamCode = undefined,
  payoutLineItemCode = undefined,
): any => action(types.GET_ALL_PAYOUT_LINE_ITEMS_REQUESTED, {
  pagination,
  compile,
  payoutLineItemView: true,
  teamCode,
  payoutLineItemCode,
});

export const selectPayoutLineItem = (payoutLineItemId): any => action(types.SELECT_PAYOUT_LINE_ITEM_REQUESTED, {
  currentPayoutLineItemId: payoutLineItemId,
});
export const clearPayoutLineItems = (): any => action(types.CLEAR_PAYOUT_LINE_ITEMS);

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createPayoutLineItemPending: (payload): any => action(types.CREATE_PAYOUT_LINE_ITEM_PENDING, payload),
  createPayoutLineItemSuccess: (response): any => action(types.CREATE_PAYOUT_LINE_ITEM_SUCCESS, {
    payoutLineItemsById: response.entities.payoutLineItems,
    currentPayoutLineItemId: response.result,
  }),
  updatePayoutLineItemPending: (payload): any => action(types.UPDATE_PAYOUT_LINE_ITEM_PENDING, payload),
  updatePayoutLineItemSuccess: (response): any => action(types.UPDATE_PAYOUT_LINE_ITEM_SUCCESS, {
    payoutLineItemsById: response.entities.payoutLineItems,
    currentPayoutLineItemId: response.result,
  }),
  updatePayoutLineItemFailed: (error): any => action(types.UPDATE_PAYOUT_LINE_ITEM_FAIL, { backendErrors: error }),
  deletePayoutLineItemPending: (response): any => action(types.DELETE_PAYOUT_LINE_ITEM_PENDING, response),
  deletePayoutLineItemSuccess: (response): any => action(types.DELETE_PAYOUT_LINE_ITEM_SUCCESS, {
    currentPayoutLineItemId: response,
  }),
  getPayoutLineItemPending: (): any => action(types.GET_PAYOUT_LINE_ITEM_PENDING, {}),
  getPayoutLineItemSuccess: (response): any => action(types.GET_PAYOUT_LINE_ITEM_SUCCESS, {
    payoutLineItemsById: response.entities.payoutLineItems,
    currentPayoutLineItemId: response.result,
  }),
  getPayoutLineItemFailed: (error): any => action(types.GET_PAYOUT_LINE_ITEM_FAIL, { backendErrors: error }),
  deletePayoutLineItemFailed: (error): any => action(types.DELETE_PAYOUT_LINE_ITEM_FAIL, { backendErrors: error }),
  getAllPayoutLineItemsPending: (pagination): any => action(types.GET_ALL_PAYOUT_LINE_ITEMS_PENDING, { pagination }),
  getAllPayoutLineItemsSuccess: (response, meta): any => action(types.GET_ALL_PAYOUT_LINE_ITEMS_SUCCESS, {
    payoutLineItemsById: response.entities.payoutLineItems,
    payoutLineItemIds: response.result,
    meta,
  }),
  getAllPayoutLineItemsFailed: (error): any => action(types.GET_ALL_PAYOUT_LINE_ITEMS_FAIL, { backendErrors: error }),
  createPayoutLineItemFailed: (error): any => action(types.CREATE_PAYOUT_LINE_ITEM_FAIL, { backendErrors: error }),
};

export default null;
